// Utility per gestire il cache FG in modo sicuro
import { logDebug } from './log';

// TODO non usato
export interface FgCache {
  fgData: any;
  timestamp: number;
  countryCode: string;
  isAllowed: boolean;
}

const FG_CACHE_KEY = 'ef_fg_cache';
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 ore

export const FgCacheManager = {
  // Salva i dati FG nella cache
  save(fgData: any, countryCode: string, isAllowed: boolean): void {
    try {
      const cacheData: FgCache = {
        fgData,
        timestamp: Date.now(),
        countryCode,
        isAllowed
      };
      localStorage.setItem(FG_CACHE_KEY, JSON.stringify(cacheData));
    } catch (error) {
      logDebug('Errore nel salvare cache FG:', error);
    }
  },

  // Recupera i dati FG dalla cache se validi
  get(): FgCache | null {
    try {
      const cached = localStorage.getItem(FG_CACHE_KEY);
      if (!cached) return null;

      const data: FgCache = JSON.parse(cached);
      const now = Date.now();

      // Controlla se la cache è scaduta
      if (now - data.timestamp > CACHE_DURATION) {
        this.clear();
        return null;
      }

      return data;
    } catch (error) {
      logDebug('Errore nel leggere cache FG:', error);
      this.clear();
      return null;
    }
  },

  // Pulisce la cache
  clear(): void {
    try {
      localStorage.removeItem(FG_CACHE_KEY);
    } catch (error) {
      logDebug('Errore nel pulire cache FG:', error);
    }
  },

  // Controlla se la cache è valida
  isValid(): boolean {
    const cached = this.get();
    return cached !== null;
  },

  // Forza l'aggiornamento della cache (pulisce quella esistente)
  forceUpdate(): void {
    this.clear();
  }
};

export default FgCacheManager;
